import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SalesSubjectMasterType } from '@/models/sales-manager/sales'
import { Cascader, Props } from '@/components/atoms/cascader'
import { css } from '@emotion/core'

interface ComponentProps extends Omit<Props, 'options' | 'value' | 'onChange'> {
  salesSubjectMasters: SalesSubjectMasterType[]
  value: string | undefined
  filterSalesDepartmentId?: string
  onChange: (v: string) => void
}

export const SubjectCascaeder: React.FC<ComponentProps> = ({
  onChange,
  value,
  salesSubjectMasters,
  filterSalesDepartmentId,
  ...otherProps
}) => {
  const { t } = useTranslation()

  const valueToCascader = (salesSubjectMasterId: string | undefined) => {
    if (!salesSubjectMasterId) {
      return []
    }

    const master = salesSubjectMasters.find(master => master.subSubjects.find(sub => sub.salesSubjectMasterId === salesSubjectMasterId))
    return [master?.id || salesSubjectMasterId, salesSubjectMasterId]
  }

  const cascadeSubjectMasterOptions = useMemo(() => {
    return salesSubjectMasters
      .filter(master => !filterSalesDepartmentId || master.departmentId === filterSalesDepartmentId)
      .map(master => {
        return {
          value: master.id,
          label: `${master.subjectCode}/${master.subjectName}`,
          children:
            master.subSubjects.length > 0
              ? master.subSubjects.map(sub => {
                  return {
                    value: sub.salesSubjectMasterId,
                    label: `${sub.subSubjectCode}/${sub.subSubjectName}`,
                  }
                })
              : undefined,
        }
      })
  }, [filterSalesDepartmentId, salesSubjectMasters])

  return (
    <Cascader
      placeholder={t('Please select')}
      options={cascadeSubjectMasterOptions}
      customStyle={css({ paddingBottom: 24 })}
      onChange={v => {
        onChange(v[1] || v[0])
      }}
      value={valueToCascader(value)}
      displayRender={label => (label.length > 1 ? `${label[0]} (${label[1]})` : label)}
      {...otherProps}
    />
  )
}
